<nav mat-tab-nav-bar class="shadow-md bg-white">
  <a mat-tab-link [routerLink]="['./', 'all']" routerLinkActive #all="routerLinkActive" [active]="all.isActive">
    <span>All</span>
  </a>
  <a
    mat-tab-link
    [routerLink]="['./', 'failed']"
    routerLinkActive
    #failed="routerLinkActive"
    [active]="failed.isActive"
  >
    <span>Only Failing OCR</span>
  </a>
</nav>
<router-outlet></router-outlet>
